import ReactECharts from 'echarts-for-react';
import http from '../../../Http';
import { useEffect, useState, useContext, useRef } from 'react';
import { DatePicker, Button } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import utils from '../../../utils';
import moment from 'moment';
import { useTranslation } from 'react-i18next';



function InverterAgilePriceChart({inverterSN}) {
    const { t } = useTranslation();
    const [date, setDate] = useState(moment());

    const refChart = useRef(null);

    const setTip = useContext(utils.tipContext);
    const opt = {
        title: {
            textStyle: {fontSize:14},
            text: "",
            subtext: t("Tariff(Pence/kWh)"),
        },
        tooltip: {
            trigger: 'axis'
        },
        legend: {
            right: "10",
            data: [t('Import Tariff'), t('Export Tariff')]
        },
        xAxis: {
            type: 'category',
            data: [],
            nameLocation: "center",
            nameGap: 25,
            axisLabel: {
                formatter: (value) => {
                    const dt = moment(value);
                    return dt.format('HH:mm')
                }
            }
        },
        yAxis: [{
            type: 'value',
        }],
        grid: {
            left: 30,
            right: 10,
            bottom: 30,
        },
        series: []
    }

    useEffect(() => {
        if (!inverterSN || !date) {
            const instance = refChart.current && refChart.current.getEchartsInstance();
            if (instance) {
                instance.setOption(opt, true);
            }

            return;
        }

        http.post(`inverter-v2/inverter-agile-price/get`, {InverterSN: inverterSN, Date: date.format('YYYY-MM-DD')}).then((r)=>{return r.json()}).then((res) => {
            console.log(res);

            if (res.code === 200) {
                const importTariff = [];
                const exportTariff = [];
                const ts = [];
                let markLineTime ="";
                res.data.forEach((item) => {
                    if (item.Direction == "IMPORT") {
                        importTariff.push(parseFloat(item.ValueIncVat));
                        ts.push(item.ValidFrom);
                        if (ts.length > 1 && ts.length < res.data.length && item.ValidFrom.indexOf("00:00:00") > 1) {
                            markLineTime = item.ValidFrom;
                        } 
                    } else {
                        exportTariff.push(parseFloat(item.ValueIncVat));
                    }
                });
                const x = {...opt};
                x.title.text = inverterSN;
                x.xAxis.data = ts;

                x.series = [
                    { name: t('Import Tariff'), type: 'line', symbol: 'circle', symbolSize: 6, data: importTariff, yAxisIndex: 0, markLine: {label: {color: 'purple', formatter: (v) => {
                        return moment(v.value).format('MM-DD')}}, 
                        data:[{xAxis:`${markLineTime}`}],}} ,
                    { name: t('Export Tariff'), type: 'line', symbol: 'diamond', symbolSize: 6, data: exportTariff, yAxisIndex: 0 },
                ]
                const instance = refChart.current && refChart.current.getEchartsInstance();
                if (instance) {
                    instance.setOption(x, true);
                }
            } else {
                const instance = refChart.current && refChart.current.getEchartsInstance();
                if (instance) {
                    instance.setOption(opt, true);
                }
                setTip({open: true, severity: 'error', msg: t("get agile price error")});
            }
        });
    }, [inverterSN, date, t]);

    return (<div>
        <div style={{display: 'flex'}}>
            <Button type="primary" icon={<LeftOutlined />} onClick={() => {setDate(date.clone().subtract(1, 'day'))}}/>
            <DatePicker value={date} allowClear={false} onChange={(date) => {setDate(date)}}/>
            <Button type="primary" icon={<RightOutlined />} onClick={() => {setDate(date.clone().add(1, 'day'))}}/>
        </div>
        <div style={{width: '100%', height: '100%', paddingTop: '3px'}}>
            <ReactECharts ref={refChart} style={{width: '100%'}} option={opt} />
        </div>
    </div>);
}

export default InverterAgilePriceChart;